import React from "react";
import ThemeToggle from "./ThemeToggle";

function Header({ onToggleSidebar, isMobile, isSidebarOpen }) {
  const toggleLabel = isMobile
    ? isSidebarOpen
      ? "Close navigation"
      : "Open navigation"
    : isSidebarOpen
    ? "Collapse navigation"
    : "Expand navigation";
  const menuState = isMobile
    ? isSidebarOpen
      ? "mobile-open"
      : "mobile-closed"
    : isSidebarOpen
    ? "expanded"
    : "collapsed";

  return (
    <header className="app-header">
      <div className="app-header__inner">
        <button
          type="button"
          className="app-header__menu"
          onClick={onToggleSidebar}
          aria-label={toggleLabel}
          aria-controls="app-sidebar"
          aria-expanded={isSidebarOpen}
          data-state={menuState}
        >
          <span className="app-header__menu-icon" aria-hidden="true" />
        </button>
        <div className="app-header__cluster">
          <a
            className="forms-button"
            href="https://kz-forms.digirockinnovations.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            Forms
          </a>
          <ThemeToggle />
          <button type="button" className="avatar-button" aria-label="Open profile">
            <svg viewBox="0 0 32 32" role="img" aria-hidden="true">
              <circle cx="16" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2" />
              <path
                d="M8 26c1.8-3.4 5.3-5.5 8-5.5s6.2 2.1 8 5.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
